import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0d8a86a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between mb-7" }
const _hoisted_3 = { class: "flex justify-start" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "relative h-42 w-288 me-3" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { id: "excel-export" }, null, -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "spinner"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, /*#__PURE__*/_toDisplayString('Export'), -1))
const _hoisted_12 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"18%"}
}
const _hoisted_13 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"18%"}
}
const _hoisted_14 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"13%"}
}
const _hoisted_15 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"13%"}
}
const _hoisted_16 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"10%"}
}
const _hoisted_17 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"9%"}
}
const _hoisted_18 = { class: "flex justify-start items-center" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"9%"}
}
const _hoisted_21 = { class: "flex justify-start items-center" }
const _hoisted_22 = { class: "me-2" }
const _hoisted_23 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"10%"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "switch" }
const _hoisted_26 = ["checked", "onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "text-center text-darkText text-lg px-4 mt-32 font-bold"
}
const _hoisted_30 = { class: "border-borderColor border-b-2 text-darkText text-md mx-8 pt-3" }
const _hoisted_31 = { class: "flex bg-transparent tab justify-between" }
const _hoisted_32 = { class: "p-8" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = {
  key: 0,
  class: "form-error"
}
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = {
  key: 0,
  class: "form-error"
}
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = {
  key: 0,
  class: "form-error"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  key: 0,
  class: "form-error"
}
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = {
  key: 0,
  class: "form-error"
}
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "text-sm" }
const _hoisted_45 = {
  key: 0,
  class: "form-error"
}
const _hoisted_46 = { class: "flex flex-wrap items-center justify-end w-full pt-4" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "relative h-42 mb-8" }
const _hoisted_49 = ["type"]
const _hoisted_50 = {
  key: 2,
  class: "flex items-center absolute start-0 -bottom-6 text-10px text-textError"
}
const _hoisted_51 = { class: "relative h-42 mb-7" }
const _hoisted_52 = ["type"]
const _hoisted_53 = {
  key: 2,
  class: "flex items-center absolute start-0 -bottom-6 text-10px text-textError"
}
const _hoisted_54 = { class: "flex flex-wrap items-center justify-end w-full pt-4" }
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_vue_excel_xlsx = _resolveComponent("vue-excel-xlsx")!
  const _component_OrderByArrow = _resolveComponent("OrderByArrow")!
  const _component_TableGhost = _resolveComponent("TableGhost")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_InviteUser = _resolveComponent("InviteUser")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, { title: "users.title" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SearchInput, {
                placeholder: _ctx.$t('users.search'),
                modelValue: _ctx.searchValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilterModal = true)),
              class: "border border-inputBorder w-42 h-42"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_BaseIcon, { name: "filter" })
              ])
            ]),
            (_ctx.showFilterModal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_FilterPanel, {
                    filters: _ctx.filters,
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = false))
                  }, null, 8, ["filters"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSuperAdmin)
              ? (_openBlock(), _createBlock(_component_vue_excel_xlsx, {
                  key: 1,
                  data: _ctx.exportData,
                  columns: _ctx.exportColumn,
                  "file-name": "users",
                  "file-type": 'xlsx',
                  "sheet-name": 'sheetname'
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("button", {
                      disabled: _ctx.exportLoading,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportUsers && _ctx.exportUsers(...args))),
                      class: "flex items-center primary px-4 py-3 rounded-md mx-3"
                    }, [
                      (!_ctx.exportLoading)
                        ? (_openBlock(), _createBlock(_component_BaseIcon, {
                            key: 0,
                            name: "file-white"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.exportLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                        : _createCommentVNode("", true),
                      _hoisted_11
                    ], 8, _hoisted_9)
                  ]),
                  _: 1
                }, 8, ["data", "columns"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = true)),
            class: "primary flex items-center px-5 py-3"
          }, [
            _createVNode(_component_BaseIcon, {
              name: "plus",
              classNames: "text-xl me-1"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('buttons.inviteUser')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "px-5 tableFixHead",
      style: _normalizeStyle({height: _ctx.height + 'px'})
    }, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('table.userName')), 1),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('table.email')), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('table.mobile')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('table.birthDate')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('table.role')), 1),
            _createElementVNode("th", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('table.joiningDate')), 1),
                _createVNode(_component_OrderByArrow, {
                  onSort: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickSort($event, 'created_at'))),
                  sortField: _ctx.sortFields[0]
                }, null, 8, ["sortField"])
              ])
            ]),
            _createElementVNode("th", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('table.lastLogin')), 1),
                _createVNode(_component_OrderByArrow, {
                  onSort: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clickSort($event, 'last_login'))),
                  sortField: _ctx.sortFields[1]
                }, null, 8, ["sortField"])
              ])
            ]),
            _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('table.status')), 1)
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(user.username), 1),
                  _createElementVNode("td", null, _toDisplayString(user.userEmail), 1),
                  _createElementVNode("td", null, _toDisplayString(user.userPhoneNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(user.birthDateFormatted), 1),
                  _createElementVNode("td", null, _toDisplayString(user.role.value), 1),
                  _createElementVNode("td", null, _toDisplayString(user.createdAtFormatted), 1),
                  _createElementVNode("td", null, _toDisplayString(user.lastLoginFormatted), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("label", _hoisted_25, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: user.activated,
                        onClick: ($event: any) => (_ctx.toggleActivate(user.id, user.activated ? 'deactivate' : 'activate'))
                      }, null, 8, _hoisted_26),
                      _hoisted_27
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.openEditUserModal(user))
                    }, [
                      _createVNode(_component_BaseIcon, { name: "edit" })
                    ], 8, _hoisted_28)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_TableGhost, {
              key: 1,
              "col-margin": "my-0",
              row: 10,
              col: 6
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.users.length && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t('validation.noItemsToShow')), 1))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.pagination && _ctx.pagination.totalItems)
      ? (_openBlock(), _createBlock(_component_Pagination, {
          key: 0,
          current: _ctx.current,
          total: _ctx.pagination.totalItems,
          "page-range": 2,
          "per-page": _ctx.pagination.pageSize,
          onPageChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.current = $event)),
          "text-before-input": "Go to page"
        }, null, 8, ["current", "total", "per-page"]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 1,
          title: _ctx.$t('users.inviteModalHeader'),
          width: '488',
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModal = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InviteUser, {
              onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getUserList())),
              onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModal = false))
            })
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showUserEditModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 2,
          title: _ctx.$t('users.editUserModalHeader'),
          width: '488',
          onClose: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closeEditUserModal()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("ul", _hoisted_31, [
                _createElementVNode("li", {
                  class: _normalizeClass(["pb-3 text-md px-10 relative cursor-pointer hover:text-black hover:border-black", {'tab-active': _ctx.activeEditTab === 'userInfo'}]),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeActive('userInfo')))
                }, _toDisplayString(_ctx.$t('users.userInfo')), 3),
                _createElementVNode("li", {
                  class: _normalizeClass(["pb-3 text-md px-10 relative cursor-pointer hover:text-black hover:border-black", {'tab-active': _ctx.activeEditTab === 'changePass'}]),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeActive('changePass')))
                }, _toDisplayString(_ctx.$t('users.changePass')), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.activeEditTab === 'userInfo')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[25] || (_cache[25] = ($event: any) => (_ctx.editUserInfo($event))),
                    class: "w-full"
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.firstName.$error}, "h-42 form-control"]),
                        type: "text",
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userInfo.firstName) = $event)),
                        onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.userInfo.firstName.$touch && _ctx.v$.userInfo.firstName.$touch(...args)))
                      }, null, 34), [
                        [_vModelText, _ctx.userInfo.firstName]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.firstName.$error}, "floating-label"])
                      }, _toDisplayString(_ctx.$t('placeholders.firstName')), 3),
                      (_ctx.v$.userInfo.firstName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.lastName.$error}, "h-42 form-control"]),
                        type: "text",
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userInfo.lastName) = $event)),
                        onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$.userInfo.lastName.$touch && _ctx.v$.userInfo.lastName.$touch(...args)))
                      }, null, 34), [
                        [_vModelText, _ctx.userInfo.lastName]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.lastName.$error}, "floating-label"])
                      }, _toDisplayString(_ctx.$t('placeholders.lastName')), 3),
                      (_ctx.v$.userInfo.lastName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userName.$error}, "h-42 form-control"]),
                        type: "text",
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userInfo.userName) = $event)),
                        onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.userInfo.userName.$touch && _ctx.v$.userInfo.userName.$touch(...args)))
                      }, null, 34), [
                        [_vModelText, _ctx.userInfo.userName]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userName.$error}, "floating-label"])
                      }, _toDisplayString(_ctx.$t('placeholders.username')), 3),
                      (_ctx.v$.userInfo.userName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userEmail.$error}, "h-42 form-control"]),
                        type: "text",
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userInfo.userEmail) = $event)),
                        onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.v$.userInfo.userEmail.$touch && _ctx.v$.userInfo.userEmail.$touch(...args)))
                      }, null, 34), [
                        [_vModelText, _ctx.userInfo.userEmail]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userEmail.$error}, "floating-label"])
                      }, _toDisplayString(_ctx.$t('placeholders.email')), 3),
                      (_ctx.v$.userInfo.userEmail.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userPhoneNumber.$error}, "h-42 form-control"]),
                        type: "text",
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userInfo.userPhoneNumber) = $event)),
                        onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.v$.userPhoneNumber.$touch && _ctx.v$.userPhoneNumber.$touch(...args)))
                      }, null, 34), [
                        [_directive_maska, { mask: '07H# ### ####', tokens: { 'H': { pattern: /[3-9]/ }}}],
                        [_vModelText, _ctx.userInfo.userPhoneNumber]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.userInfo.userPhoneNumber.$error}, "floating-label"])
                      }, _toDisplayString(_ctx.$t('placeholders.userPhoneNumber')), 3),
                      (_ctx.v$.userInfo.userPhoneNumber.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.v$.mobile.minLength.$invalid ? _ctx.$t('validation.min_length', {length: 11}) : _ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('placeholders.birthDate')), 1),
                      _createVNode(_component_Datepicker, {
                        format: 'MM/dd/yyyy',
                        modelValue: _ctx.userInfo.birthDate,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.userInfo.birthDate) = $event)),
                        placeholder: _ctx.$t('placeholders.birthDate')
                      }, null, 8, ["modelValue", "placeholder"]),
                      (_ctx.v$.userInfo.birthDate.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeEditUserModal())),
                        class: "secondary m-1 w-32 px-4 py-2"
                      }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                      _createElementVNode("button", {
                        disabled: _ctx.v$.userInfo.$invalid,
                        type: "submit",
                        class: "primary m-1 w-32 px-4 py-2"
                      }, _toDisplayString(_ctx.$t('buttons.update')), 9, _hoisted_47)
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.activeEditTab === 'changePass')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[35] || (_cache[35] = ($event: any) => (_ctx.changePassword($event))),
                    class: "w-full"
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.changePass.pass.$error}, "h-42 absolute p-3.5 top-0 start-0 w-full h-full block appearance-none bg-transparent"]),
                        type: this.showPassword ? 'text' : 'password',
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.changePass.pass) = $event)),
                        onBlur: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.v$.changePass.pass.$touch && _ctx.v$.changePass.pass.$touch(...args)))
                      }, null, 42, _hoisted_49), [
                        [_vModelDynamic, _ctx.changePass.pass]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.changePass.pass.$error}, "absolute text-placeholder top-3 start-4 text-xs bg-white py-0 px-1 -z-1 duration-300 origin-0 cursor-text"])
                      }, _toDisplayString(_ctx.$t('auth.password')), 3),
                      (_ctx.showPassword)
                        ? (_openBlock(), _createBlock(_component_BaseIcon, {
                            key: 0,
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showPassword = false)),
                            class: "input-icon absolute end-3.5 top-3 cursor-pointer z-30",
                            name: "eye"
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.showPassword)
                        ? (_openBlock(), _createBlock(_component_BaseIcon, {
                            key: 1,
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showPassword = true)),
                            class: "input-icon absolute end-3.5 top-3 cursor-pointer z-30",
                            name: "eyeoff"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.v$.changePass.pass.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.required')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([{error: _ctx.v$.changePass.confirm_pass.$error}, "h-42 absolute p-3.5 top-0 start-0 w-full h-full block appearance-none bg-transparent"]),
                        type: this.showConfirmPassword ? 'text' : 'password',
                        placeholder: " ",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.changePass.confirm_pass) = $event)),
                        onBlur: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.v$.changePass.confirm_pass.$touch && _ctx.v$.changePass.confirm_pass.$touch(...args)))
                      }, null, 42, _hoisted_52), [
                        [_vModelDynamic, _ctx.changePass.confirm_pass]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass([{error: _ctx.v$.changePass.confirm_pass.$error}, "absolute text-placeholder top-3 start-4 text-xs bg-white py-0 px-1 -z-1 duration-300 origin-0 cursor-text"])
                      }, _toDisplayString(_ctx.$t('auth.password_confirm')), 3),
                      (_ctx.showConfirmPassword)
                        ? (_openBlock(), _createBlock(_component_BaseIcon, {
                            key: 0,
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showConfirmPassword = false)),
                            class: "input-icon absolute end-3.5 top-3 cursor-pointer z-30",
                            name: "eye"
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.showConfirmPassword)
                        ? (_openBlock(), _createBlock(_component_BaseIcon, {
                            key: 1,
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showConfirmPassword = true)),
                            class: "input-icon absolute end-3.5 top-3 cursor-pointer z-30",
                            name: "eyeoff"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.v$.changePass.confirm_pass.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                            _createVNode(_component_BaseIcon, {
                              class: "me-1",
                              name: "alert"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.same_as')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.closeEditUserModal())),
                        class: "secondary m-1 w-32 px-4 py-2"
                      }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                      _createElementVNode("button", {
                        disabled: _ctx.v$.changePass.$invalid,
                        type: "submit",
                        class: "primary m-1 w-32 px-4 py-2"
                      }, _toDisplayString(_ctx.$t('buttons.update')), 9, _hoisted_55)
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}